const site = site || {};
site.Navigation = (() => {
    // Functions

    // const functionName = () => {
    //
    // };

    const setActiveNav = () => {
        const pageNavs = document.querySelectorAll('.js-page-nav-group');
        pageNavs.forEach(nav => {
            const navId = nav.id;
            const itemId = nav.querySelector('.nav-link.active').getAttribute('data-item-id')
            const activeSidebarNavGroup = document.querySelector('[data-nav-group="' + navId + '"]')
            const activeSidebarNavItem = activeSidebarNavGroup.querySelector('[data-item-id="' + itemId + '"]')
            
            activeSidebarNavGroup.querySelector('[data-bs-toggle="collapse"]').attributes.ariaExpanded = true;
            activeSidebarNavGroup.querySelector('.collapse').classList.add('show');
            activeSidebarNavItem.classList.add('active');

            
            nav.querySelector('.nav-link.active').scrollIntoView({
                behavior: "instant",
                inline: "center"
            });
        })
    }

    // Return
    return {
        // functionName : functionName
        setActiveNav : setActiveNav,
    };
})();